
export const StandardPlanData = {
    IN: [
        "2 FREE user License",
        "Sales chat box",
        "5 bot flows",
        "Campaign scheduler",
        "Whatsapp Catalogue",
        "Bulk product upload",
        "WhatsApp Broadcast Analytics",
        "Ticketing system (using Round Robin)",
        "Mobile App (Available on Android & IOS)",
        "Additional users licence ₹1199 /Month per user"
    ],
    otherCountry: [
        "2 FREE user License",
        "Sales chat box",
        "5 bot flows",
        "Campaign scheduler",
        "Whatsapp Catalogue",
        "Bulk product upload",
        "WhatsApp Broadcast Analytics",
        "Ticketing system (using Round Robin)",
        "Mobile App (Available on Android & IOS)",
        "Additional users licence ₹1199 /Month per user"
    ]
};

export const amounts = {
    IN: "2499",
    otherCountry: 29
};

export const conversationDetails = {
    IN: "Conversation charges: As per Meta rates",
    otherCountry: "Conversation charges: As per Meta rates"
};

export const additionalUserLicenseDetails = {
    IN: "₹1199 /Month per user",
    otherCountry: "$15/Month per user"
};
